"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Card_1 = require("../Card");
const DetailCard = ({ children, title, actions }) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: "pb-3 text-black", children: (0, jsx_runtime_1.jsx)(Card_1.Card, { children: (0, jsx_runtime_1.jsxs)(Card_1.CardBody, { children: [(0, jsx_runtime_1.jsx)(Card_1.CardHeader, { glueBottom: true, actions: actions, children: title }), (0, jsx_runtime_1.jsx)(Card_1.CardSection, { glueBottom: true, children: children })] }) }) }));
};
exports.DetailCard = DetailCard;
